import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { connect } from 'react-redux';

import { CircularLoaderComponent } from '../LoadingSpinner/LoadingSpinnerComponent';
import DeliveryTypesFormComponent from './DeliveryTypesFormComponent';

import {
  createDeliveryType,
  getCountries,
  getDeliveryTypeById,
  updateDeliveryType,
} from './actions';

import { formatSelect } from '../Forms/utils';

const form = 'DeliveryType';

const DeliveryTypeFormContainer = (props) => {
  const { onLoad, countriesOptions, initialValues, isCreate } = props;

  useEffect(() => {
    onLoad && onLoad();
  }, []);

  if ((!isCreate && !initialValues?.name) || !countriesOptions?.length) {
    return <CircularLoaderComponent />;
  }
  if (isCreate && !countriesOptions?.length) {
    return <CircularLoaderComponent />;
  }

  return <DeliveryTypesFormComponent {...props} />;
};

DeliveryTypeFormContainer.propTypes = {
  onLoad: PropTypes.func.isRequired,
  countriesOptions: PropTypes.instanceOf(Array).isRequired,
  initialValues: PropTypes.instanceOf(Object).isRequired,
  isCreate: PropTypes.bool.isRequired,
};

const mapStateToProps = (state, ownProps) => {
  const {
    deliveryType,
    common: { countries },
  } = state;
  const typeId = ownProps?.match?.params?.id;
  const isCreate = typeId === 'create';
  const initialValues = {
    enabled: true,
    initialValueForBuildings: true,
    ...deliveryType,
  };
  return {
    form,
    initialValues,
    isCreate,
    countriesOptions: formatSelect(countries, 'name', 'id'),
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const typeId = ownProps?.match?.params?.id;
  const isCreate = typeId === 'create';
  return {
    onLoad: () => {
      getCountries(dispatch);
      !isCreate && getDeliveryTypeById(dispatch, typeId);
    },
    onSubmit: (data) =>
      isCreate
        ? createDeliveryType(dispatch, data)
        : updateDeliveryType(dispatch, typeId, data),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DeliveryTypeFormContainer);
